<template>
  <div class="action" :class="{ wicon: icon }" @click="click">
    <div class="icon" v-if="icon">
      <icon :name="icon"/>
    </div>
    <span class="link">
      <slot></slot>
    </span>
  </div>
</template>

<script>
import Link from '../../mixins/Link.vue'

export default {
  props: {
    icon: {
      default: 'record',
    },
  },
  mixins: [Link],
  methods: {
    click($event) {
      this.go()
      this.$emit('click', $event)
    },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.action {
  cursor: pointer;
  display: block;
  font-size: $h7;
  font-weight: 600;
  line-height: $lh;
  position: relative;
  text-align: center;
  .link {
    color: $c-link;
    text-transform: uppercase;
  }
  > .icon {
    display: inline-block;
    // left: 0;
    // position: relative;
    width: 1rem;
  }
  // &.hasText {
  //   > .icon {}
  // }
  // &.wicon {
  //   padding-left: 1.5rem;
  // }
  &:hover {
    background: #eee;
    .link {
      color: $c-link-hover;
      // color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Action.vue